import store from '../store';
import utilities from './utilities';
//import server from 'server';
import server from '../../test/data/server';

export default {
    get: function(url, errorMutation) {
        if (errorMutation) {
            store.commit(errorMutation,
                {},
                { root: true });
        }

        return server.get(url).then(function(response) {
                return response;
            },
            function(response) {
                utilities.handleErrors(response.status, response.body, errorMutation);
                throw new Error();
            });
    },
    post: function(url, data, errorMutation) {
        if (errorMutation) {
            store.commit(errorMutation,
                {},
                { root: true });
        }

        return server.post(url, data).then(function(response) {
                return response;
            },
            function(response) {
                utilities.handleErrors(response.status, response.body, errorMutation);
                throw new Error();
            });
    },
    put: function (url, data, errorMutation) {
        if (errorMutation) {
            store.commit(errorMutation,
                {},
                { root: true });
        }

        return server.put(url, data).then(function (response) {
                return response;
            },
            function (response) {
                utilities.handleErrors(response.status, response.body, errorMutation);
                throw new Error();
            });
    },
    delete: function(url, errorMutation) {
        if (errorMutation) {
            store.commit(errorMutation,
                {},
                { root: true });
        }

        return server.delete(url).then(function(response) {
                return response;
            },
            function(response) {
                utilities.handleErrors(response.status, response.body, errorMutation);
                throw new Error();
            });
    }
};



// WEBPACK FOOTER //
// ./src/utils/api.js